import { useMemo } from 'react';
import { links } from '../constants/links';
import { useSelector } from 'react-redux';
const { transports, permits } = links;

const useGetMenu = () => {
  const { AllowTransportPermit } =
    useSelector((state) => state.authentication.userInfo) || {};

  return useMemo(() => {
    const menuItems = [
      {
        key: transports,
        content: 'Транспортные средства',
      },
    ];

    if (!!AllowTransportPermit) {
      menuItems.push({
        key: permits,
        content: 'Пропуска',
      });
    }

    return menuItems;
  }, [AllowTransportPermit]);
};

export default useGetMenu;
